import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterExtensions } from '@luggagehero/core';
import { BookingsUserBaseComponent } from '@luggagehero/features/bookings';
import { Config } from '@luggagehero/shared/environment';
import { SharedBookingService } from '@luggagehero/shared/services/bookings';
import { SharedDocumentService } from '@luggagehero/shared/services/document';
import { SharedUserService } from '@luggagehero/shared/services/users';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lh-bookings-user',
  templateUrl: './bookings-user.component.html',
  styleUrls: ['./bookings-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingsUserComponent extends BookingsUserBaseComponent implements OnInit {
  constructor(
    bookingService: SharedBookingService,
    userService: SharedUserService,
    translate: TranslateService,
    router: RouterExtensions,
    document: SharedDocumentService,
    cd: ChangeDetectorRef,
  ) {
    super(bookingService, userService, translate, router, document, cd);
  }

  ngOnInit() {
    if (this.isShopOwner) {
      this.document.document.location.href = Config.environment.STORAGE_MANAGER_UI;
    }
    super.ngOnInit();
  }
}
